import axios from "../../utils/axios";
import { Method } from "axios";
import { useState } from "react";
import { Control, useForm, UseFormReset, UseFormWatch } from "react-hook-form";
import { errorParser } from "./Form.utils";
import { Button } from "djinn-components";

export interface FormRenderProps {
  reset: UseFormReset<any>;
  control: Control<any, object>;
  errors: any;
  watch: UseFormWatch<any>;
  isDirty: boolean;
}
interface FormProps {
  getDefaults?: any;
  onCompleted: any;
  className?: string;
  render: (props: FormRenderProps) => any;
  buttonTitle?: string;
  endpoint: string;
  method?: Method;
  transformRequestData?: (data: any) => any;
  showReset?: boolean;
}

const Form: React.FC<FormProps> = ({
  getDefaults = () => {},
  onCompleted,
  className = "",
  render,
  buttonTitle = "Submit",
  endpoint,
  method = "post",
  showReset = true,
  transformRequestData = (data: any) => data,
}) => {
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    control,
    setError,
    watch,
  } = useForm({
    defaultValues: getDefaults(),
  });

  const onFormSubmit = async (formData: any) => {
    setLoading(true);

    try {
      const { data } = await axios({
        method,
        url: endpoint,
        data: transformRequestData(formData),
      });
      reset(formData);
      await onCompleted(data);
    } catch (error) {
      if (process.env.NODE_ENV === "development") {
        console.error(error);
      }
      errorParser(error, setError);
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)} className={className}>
      {render({ reset, control, errors, watch, isDirty })}

      <div className="flex items-center">
        <div className="w-[180px]">
          <Button
            type="submit"
            text={loading ? "Loading..." : buttonTitle}
            disabled={loading || !isDirty}
            buttonStyle="green"
          />
        </div>
        {showReset && isDirty && (
          <div
            className="ml-2 pl-3 pr-3 cursor-pointer text-gray-400 hover:text-gray-100"
            onClick={() => reset(getDefaults())}
          >
            Reset
          </div>
        )}
      </div>
    </form>
  );
};

export default Form;
